/**
 * Agenda Event Tiles JavaScript
 * Handles event tile interactions and animations
 */

(function($) {
    'use strict';

    // Event Tiles functionality
    const AgendaEventTiles = {
        
        init: function() {
            this.setupEventTiles();
            this.setupAnimations();
            this.setupEventHandlers();
        },

        setupEventTiles: function() {
            // Add smooth hover effects
            $('.event-tile').on('mouseenter', function() {
                $(this).addClass('hovered');
            }).on('mouseleave', function() {
                $(this).removeClass('hovered');
            });
        },

        setupAnimations: function() {
            // Intersection Observer for scroll animations
            if (window.IntersectionObserver) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const tiles = entry.target.querySelectorAll('.event-tile');
                            tiles.forEach((tile, index) => {
                                setTimeout(() => {
                                    tile.style.opacity = '1';
                                    tile.style.transform = 'translateY(0)';
                                }, index * 150);
                            });
                            observer.unobserve(entry.target);
                        }
                    });
                }, {
                    threshold: 0.1
                });

                // Observe event tiles sections
                document.querySelectorAll('.event-tiles-section').forEach(section => {
                    observer.observe(section);
                });
            }
        },

        setupEventHandlers: function() {
            // Event button click handlers
            $('.event-btn').on('click', function(e) {
                //e.preventDefault();
                //const eventTitle = $(this).closest('.event-tile').find('h4').text();
                //console.log('Event clicked:', eventTitle);
                
                //// Add your event registration logic here
                //// For example: opening a modal, redirecting to registration page, etc.
                
                //// Example: Show alert (replace with actual functionality)
                ////alert('Registratie voor "' + eventTitle + '" - functionaliteit nog toe te voegen');
            });

            // Event tag click handlers (optional)
            $('.event-tag').on('click', function(e) {
                e.preventDefault();
                const tagText = $(this).text();
                console.log('Tag clicked:', tagText);
                
                // Add filtering logic here if needed
                // For example: filter events by tag type
            });
        },
        // Utility method to add new event tile dynamically
        addEventTile: function(eventData) {
            const eventHtml = `
                <div class="col-lg-4 col-md-6">
                    <div class="event-tile">
                        <div class="event-tile-header">
                            <div class="event-tile-date">${eventData.date}</div>
                            <div class="event-tile-month">${eventData.month}</div>
                        </div>
                        <div class="event-tile-content">
                            <h4>${eventData.title}</h4>
                            <div class="event-tile-time">
                                <i class="fas fa-clock"></i> ${eventData.time}
                            </div>
                            <p>${eventData.description}</p>
                            <div class="mb-3">
                                ${eventData.tags.map(tag => `<span class="event-tag ${tag.class}">${tag.text}</span>`).join('')}
                            </div>
                            <a href="${eventData.link || '#'}" class="event-btn">Aanmelden</a>
                        </div>
                    </div>
                </div>
            `;
            
            return eventHtml;
        },

        // Method to filter events by tag
        filterEventsByTag: function(tagClass) {
            $('.event-tile').each(function() {
                const $tile = $(this);
                const hasTag = $tile.find(`.event-tag.${tagClass}`).length > 0;
                
                if (tagClass === 'all' || hasTag) {
                    $tile.closest('.col-lg-4').show();
                } else {
                    $tile.closest('.col-lg-4').hide();
                }
            });
        },

        // Method to reset all filters
        resetFilters: function() {
            $('.event-tile').closest('.col-lg-4').show();
        }
    };

    // Initialize when document is ready
    $(document).ready(function() {
        AgendaEventTiles.init();
    });

    // Make AgendaEventTiles available globally
    window.AgendaEventTiles = AgendaEventTiles;

})(jQuery);

// Additional utility functions (vanilla JS)
document.addEventListener('DOMContentLoaded', function() {
    
    // Add CSS animation classes for initial state
    const eventTiles = document.querySelectorAll('.event-tile');
    eventTiles.forEach(tile => {
        tile.style.opacity = '0';
        tile.style.transform = 'translateY(30px)';
        tile.style.transition = 'all 0.6s ease';
    });

    // Add scroll-triggered animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe all event tiles
    eventTiles.forEach(tile => {
        scrollObserver.observe(tile);
    });

    // Add staggered animation delays
    eventTiles.forEach((tile, index) => {
        tile.style.transitionDelay = `${index * 0.1}s`;
    });
});